<div class="landing-conversion">
  @if (isLoadingEmail) {
    <mat-progress-bar
      mode="indeterminate"
      [ngClass]="'landing-conversion__progress-bar'"
    ></mat-progress-bar>
  }
  <div
    class="landing-conversion__table-container"
    id="table-container"
  >
    <app-table
      [columnHeaders]="columnHeaders"
      [displayedColumns]="displayedColumns"
      [backendPagination]="false"
      [data]="conversions"
      [pageSize]="pageSize"
      [loading]="isLoadingConversions"
      [selectionMode]="selectionMode"
      (selectedChange)="onSelectedChange($event)"
      (refresh)="onRefresh()"
      (pageChange)="onPageChange()"
      class="landing-conversion__table"
    >
    </app-table>
  </div>

  <div class="landing-conversion__form-interactions">
    @if (selectedConversion && selectedInteraction) {
      <app-conversion-form
        [selectedInteraction]="selectedInteraction"
        [selectedHistoryInteraction]="selectedHistoryInteraction"
        (convertedEvent)="onProcessLandingConversion($event)"
        class="landing-conversion__form-container"
      ></app-conversion-form>
    }

    @if (selectedConversion) {
      <div class="landing-conversion__interactions-container">
        <div class="landing-conversion__search-leads">
          <app-mail-classifier-search-leads></app-mail-classifier-search-leads>
        </div>
      </div>
    }
  </div>
</div>
